import React, { useEffect, useRef, useState } from 'react';
// const adClient = 'ca-pub-2450504890423764';
// const layoutKey = '-fb+5w+4e-db+86';
// const adSlot = '3378068224';


const GoogleAd = () => {
    // ref for the ad container itself
    const adRef = useRef(null);
    // ref for the parent container, used to check its width
    const parentRef = useRef(null);

    // State to control rendering of the ins tag
    const [isParentWideEnough, setIsParentWideEnough] = useState(false);

    useEffect(() => {
        // This effect runs once to check the parent's width
        if (parentRef.current) {
            const checkWidth = () => {
                if (parentRef.current.offsetWidth >= 250) {
                    setIsParentWideEnough(true);
                } else {
                    setIsParentWideEnough(false);
                }
            };

            // Check width immediately
            checkWidth();

            // Also check on window resize, as the width can change
            window.addEventListener('resize', checkWidth);

            // Cleanup
            return () => {
                window.removeEventListener('resize', checkWidth);
            };
        }
    }, []); // Empty dependency array, runs once on mount

    useEffect(() => {
        // This effect runs only when isParentWideEnough becomes true
        if (isParentWideEnough && adRef.current) {
            try {
                // The push({}) call should now be reliable as the container is ready
                (window.adsbygoogle = window.adsbygoogle || []).push({});
                console.log('Ad loading triggered.');
            } catch (e) {
                console.error("Ad failed to load:", e);
            }
        }
    }, [isParentWideEnough]); // Only re-run when the condition is met

    // Render a placeholder until the parent is wide enough
    if (!isParentWideEnough) {
        return (
            <div ref={parentRef} style={{ width: '100%', minHeight: '280px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#aaff00', border: '1px dashed #66ff00' }}>
                <p>Loading sponsored content...</p>
            </div>
        );
    }

    // Once the parent is wide enough, render the actual ad slot
    return (
        <div ref={parentRef} style={{ width: '100%' }}>
            <ins
                ref={adRef}
                className="adsbygoogle"
                style={{
                    display: 'block',
                    minHeight: '280px',
                    width: '100%'
                }}
                data-ad-format="fluid"
                data-ad-layout-key="-fb+5w+4e-db+86"
                data-ad-client="ca-pub-2450504890423764"
                data-ad-slot="3378068224"
            />
        </div>
    );
};

export default GoogleAd;